import { fetchJson } from "../lib/api";

export type CreditCostCenterReview = {
  line: {
    doc_id: string;
    line_pos: string;
    article_code: string | null;
    description: string | null;
    qty: string | null;
    uom: string | null;
    context_project_code: string | null;
    context_customer_ref_raw: string | null;
    context_delivery_address_raw: string | null;
    page_no: number | null;
  };
  pdf_available: boolean;
  source_binding: string;
  revision: number;
  decision: {
    status: "assigned" | "deferred" | "open";
    target_key: string | null;
    source_binding: string;
    revision: number;
  } | null;
  decision_active: boolean;
  decision_issue: string | null;
  reason: string;
  invoice_evidence: Array<{
    doc_id: string;
    doc_number: string | null;
    doc_date: string | null;
    pdf_available: boolean;
    line_pos: string;
    project_key: string | null;
    delivery_address: string | null;
  }>;
  history: Array<{
    event_id: string;
    action: "assign" | "defer" | "undo";
    after: { status: string; target_key: string | null };
    actor_label: string;
    reason: string;
    created_at: string;
  }>;
};

export type CreditCostCenterTarget = {
  type: string;
  key: string;
  label: string;
};

const base = "/api/credit-cost-center-review";
const positionUrl = (docId: string, linePos: string) =>
  `${base}/${encodeURIComponent(docId)}/${encodeURIComponent(linePos)}`;

export function fetchCreditCostCenterReview(docId: string, linePos: string) {
  return fetchJson<CreditCostCenterReview>(positionUrl(docId, linePos));
}

export function fetchCreditCostCenterTargets(query: string) {
  return fetchJson<{ items: CreditCostCenterTarget[] }>(
    `${base}/targets?q=${encodeURIComponent(query)}`,
  );
}

export function saveCreditCostCenterReview(input: {
  docId: string;
  linePos: string;
  requestId: string;
  action: "assign" | "defer" | "undo";
  targetKey: string | null;
  reason: string;
  expectedRevision: number;
  expectedBinding: string;
}) {
  return fetchJson<CreditCostCenterReview>(positionUrl(input.docId, input.linePos), {
    method: "POST",
    body: JSON.stringify({
      request_id: input.requestId,
      action: input.action,
      target_key: input.targetKey,
      reason: input.reason,
      expected_revision: input.expectedRevision,
      expected_binding: input.expectedBinding,
    }),
  });
}
